import filterIcon from '../icons/filterList.svg';
class ColumnFilterIcon {
    constructor(showColumnFilterEventHandler, field) {
        this.showColumnFilterEventHandler = showColumnFilterEventHandler;
        this.field = field;
        this.onIconClicked = this.onIconClicked.bind(this);
        this.render = this.render.bind(this);
    }
    render() {
        let div = document.createElement('div');
        div.classList.add('dwc-datagrid-col-filter');
        let icon = document.createElement('div');
        icon.classList.add('dwc-datagrid-col-filter-icon');
        icon.innerHTML = filterIcon;
        div.appendChild(icon);
        div.addEventListener('click', this.onIconClicked);
        return div;
    }
    onIconClicked(event) {
        this.showColumnFilterEventHandler(this.field);
    }
}
export class ColHeaders {
    constructor(grid) {
        this.filterIcons = [];
        this.checkSelects = {};
        this.grid = grid;
        this.titleClickHandler = this.titleClickHandler.bind(this);
        this.checkSelectHandler = this.checkSelectHandler.bind(this);
        this.onNewPage = this.onNewPage.bind(this);
        this.sortOrderChanged = grid.sortorderChanged;
        this.showColumnFilter = grid.showColumnFilter;
    }
    onNewPage(fullySelectedFields) {
        Object.keys(this.checkSelects).forEach(field => {
            let checkSelect = this.checkSelects[field];
            let checked = fullySelectedFields.includes(field);
            checkSelect.checked = checked;
        });
    }
    checkSelectHandler(event) {
        let checkSelect = event.currentTarget;
        let field = checkSelect.dataset.field;
        if (field) {
            let checked = checkSelect.checked;
            this.grid.selectAll(field, checked);
        }
        else {
            console.error("CheckSelect dataset.field is not defined");
        }
    }
    titleClickHandler(event) {
        let title = event.currentTarget;
        let field = title.dataset.field;
        if (!field)
            return;
        let colDef = this.grid.columns[field];
        if (colDef === null || colDef === void 0 ? void 0 : colDef.sortable) {
            let table = title.closest('table');
            if (table === null || table === void 0 ? void 0 : table.classList.contains('sorting')) {
                return;
            }
            let container = title.closest('.dwc-datagrid-header-content');
            if (!container)
                return;
            let updownIcon = container === null || container === void 0 ? void 0 : container.querySelector('.dwc-datagrid-updown-icon');
            let newOrder = 'none';
            if (updownIcon) {
                if (updownIcon.classList.contains('ascending')) {
                    newOrder = 'descending';
                    updownIcon.classList.remove('ascending');
                }
                else if (updownIcon.classList.contains('descending')) {
                    updownIcon.classList.remove('descending');
                    newOrder = 'none';
                }
                else {
                    newOrder = 'ascending';
                }
            }
            if (!event.shiftKey) {
                let headerRow = container.closest('tr');
                let icons = headerRow === null || headerRow === void 0 ? void 0 : headerRow.querySelectorAll('.dwc-datagrid-updown-icon');
                icons === null || icons === void 0 ? void 0 : icons.forEach(icon => {
                    icon.classList.remove('ascending');
                    icon.classList.remove('descending');
                });
            }
            if (updownIcon) {
                updownIcon.classList.add(newOrder);
                this.sortOrderChanged(field, newOrder, event.shiftKey);
            }
        }
    }
    render() {
        let thead = document.createElement('thead');
        let tr = document.createElement('tr');
        let columns = this.grid.orderColumns();
        columns.forEach(col => {
            if (col.hidden) {
                return;
            }
            let th = this._renderHeader(col);
            tr.appendChild(th);
        });
        thead.appendChild(tr);
        return thead;
    }
    _renderUpdownIcon() {
        let updownIcon = document.createElement('div');
        updownIcon.classList.add('dwc-datagrid-updown-icon');
        let upIcon = document.createElement('div');
        upIcon.classList.add('up');
        upIcon.innerHTML = '&#x25B2;';
        updownIcon.appendChild(upIcon);
        let downIcon = document.createElement('div');
        downIcon.classList.add('down');
        downIcon.innerHTML = '&#x25BC;';
        updownIcon.appendChild(downIcon);
        return updownIcon;
    }
    _renderHeaderTitleDiv(col) {
        let titleDiv = document.createElement('div');
        titleDiv.classList.add('dwc-datagrid-header-title');
        let singleSelect = this.grid.isSingleSelect();
        if (col.dataType == "checkSelect" && !singleSelect) {
            let checkSelect = document.createElement('input');
            checkSelect.type = 'checkbox';
            checkSelect.classList.add('dwc-datagrid-checkselect');
            checkSelect.classList.add('header-select');
            checkSelect.dataset.field = col.field;
            checkSelect.addEventListener('change', this.checkSelectHandler);
            this.checkSelects[col.field] = checkSelect;
            titleDiv.appendChild(checkSelect);
        }
        else {
            titleDiv.textContent = col.title;
            titleDiv.addEventListener('click', this.titleClickHandler);
            titleDiv.dataset.field = col.field;
        }
        return titleDiv;
    }
    _renderHeader(col) {
        let th = document.createElement('th');
        if (col.thCellClass) {
            th.classList = col.thCellClass;
        }
        th.setAttribute('data-field', col.field.trim().toLowerCase());
        if (col.sortable) {
            th.classList.add('dwc-datagrid-column-sortable');
        }
        let headerContent = document.createElement('div');
        headerContent.classList.add('dwc-datagrid-header-content');
        th.appendChild(headerContent);
        if (col.sortable) {
            let updownIcon = this._renderUpdownIcon();
            headerContent.appendChild(updownIcon);
        }
        let titleDiv = this._renderHeaderTitleDiv(col);
        headerContent.appendChild(titleDiv);
        if (col.filterable) {
            let colFilter = new ColumnFilterIcon(this.showColumnFilter, col.field);
            this.filterIcons.push(colFilter);
            let filterDiv = colFilter.render();
            headerContent.appendChild(filterDiv);
        }
        return th;
    }
}
